import { render, staticRenderFns } from "./masterSettingView.vue?vue&type=template&id=3bbacf4b&"
import script from "./masterSettingView.vue?vue&type=script&lang=js&"
export * from "./masterSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports